<script setup>
import VideoPlayer from '../../VideoPlayer.vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const messages = computed(() => props.item.enrichment.messages.slice(0, 6))
</script>

<template>
  <div class="size-full wall-grid gap-8 5tv:gap-16 p-20 5tv:p-40 font-cervo">
    <div v-for="message in messages" :key="message.id" class="bg-q-cr-gray-primary text-white rounded-3xl 5tv:rounded-[6rem] flex flex-col items-center justify-center overflow-clip @container">
      <div class="flex-1 w-full flex items-center overflow-hidden">
        <div v-if="message.image" class="size-full flex-1 relative">
          <img :src="message.image" class="size-full object-cover blur-xl scale-125" />
          <img :src="message.image" class="absolute top-0 left-0 size-full object-contain" />
        </div>
        <div v-else-if="message.video" class="size-full flex-1 relative">
          <VideoPlayer autoplay muted loop :src="message.video" class="size-full object-cover blur-xl scale-125" />
          <VideoPlayer autoplay muted loop :src="message.video" class="absolute top-0 left-0 size-full object-contain" />
        </div>
        <div v-else class="flex-1 pt-4 5tv:pt-8 px-8 5tv:px-16 font-bold text-center text-5xl 5tv:text-7xl @[2000px]:text-9xl line-clamp-6 @[2000px]:line-clamp-5">{{ message.message }}</div>
      </div>
      <div v-if="(message.image || message.video) && message.message" class="pt-4 5tv:pt-8 px-8 5tv:px-16 font-bold text-center text-4xl 5tv:text-7xl line-clamp-1 -mb-4">{{ message.message }}</div>
      <p class="text-3xl 5tv:text-6xl pt-6 pb-4 5tv:pb-8">{{ message.from.name }}</p>
    </div>
  </div>
</template>

<style scoped>
.wall-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(7, 1fr);
}

.wall-grid > div:nth-of-type(1) {
  grid-area: 1 / 1 / 5 / 3;
}

.wall-grid > div:nth-of-type(2) {
  grid-area: 4 / 3 / 8 / 5;
}
.wall-grid > div:nth-of-type(3) {
  grid-area: 1 / 4 / 4 / 5;
}
.wall-grid > div:nth-of-type(4) {
  grid-area: 8 / 1 / 5 / 2;
}
.wall-grid > div:nth-of-type(5) {
  grid-area: 8 / 3 / 5 / 2;
}
.wall-grid > div:nth-of-type(6) {
  grid-area: 1 / 3 / 4 / 4;
}
</style>
